module.exports = __webpack_public_path__ + "img/SC-PROOF-2999.46081029.png";